import React from "react"

import { useStaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./logo.module.scss"
import LogoSvgLight from "../../../images/logo-light.svg"
import LogoSvg from "../../../images/logo.svg"

const Logo = ({ light, logo, url, full, alt, small }) => {
  const { title } = useStaticQuery(graphql`
    {
      title: sanityDictionary(key: { current: { eq: "title" } }) {
        value
      }
    }
  `)

  const logoSrc = light ? LogoSvgLight : LogoSvg
  return (
    <div className={styles.logo}>
      <Link
        to={url || "/"}
        className={`${styles.link} ${full ? styles.link__full : ""}`}
      >
        {logo ? (
          <Image
            {...logo}
            className={`${styles.img} ${full ? styles.img__full : ""} ${small ? styles.img__small : ""}`}
            width={200}
          />
        ) : (
          <img
            className={`${styles.img} ${full ? styles.img__full : ""}  ${small ? styles.img__small : ""}`}
            src={logoSrc}
            alt={alt || title?.value}
          />
        )}
      </Link>
    </div>
  )
}

export default Logo

Logo.propTypes = {
  light: PropTypes.bool,
  logo: PropTypes.string,
  url: PropTypes.string,
  full: PropTypes.bool,
  alt: PropTypes.string,
  small: PropTypes.bool,
}

Logo.defaultProps = {
  light: false,
  logo: "",
  url: "",
  full: false,
  alt: "",
  small: false,
}
